import { InfoIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { HStack, Text } from "@whoosh/design-system/src/components/primitive";
import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";
import {
  CustomColor,
  getLightSurfaceColor,
} from "@whoosh/utilities/src/colors";

type Props = {
  name: string;
  displayName: string | null;
  visibilityColor?: string | null;
};

const getRestrictionColor = (
  visibilityColor?: string | null
): CustomColor | null => {
  switch (visibilityColor) {
    case "A":
    case "B":
    case "C":
    case "D":
    case "E":
    case "F":
      return visibilityColor;
    default:
      return null;
  }
};

export const InlineRestriction = ({
  name,
  displayName,
  visibilityColor,
}: Props) => {
  const restrictionName = displayName || name;
  const backgroundColor: WhooshThemeColors = getLightSurfaceColor(
    getRestrictionColor(visibilityColor) ?? "A"
  );

  return (
    <HStack bg={backgroundColor} p={2} borderRadius="2" gap={2}>
      <InfoIcon />
      <Text variant="mainSmallSemiBold">{restrictionName}</Text>
    </HStack>
  );
};
